import { render, staticRenderFns } from "./Teprosif.vue?vue&type=template&id=149f620a&scoped=true"
import script from "./Teprosif.vue?vue&type=script&lang=js"
export * from "./Teprosif.vue?vue&type=script&lang=js"
import style0 from "./Teprosif.vue?vue&type=style&index=0&id=149f620a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149f620a",
  null
  
)

export default component.exports